import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { getTranslations } from 'next-intl/server';
import { BadgeX, HomeIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getAppLocale } from '@/lib/utils.server';
type PropsType = {
  localized?: boolean;
};
const NotFoundPageContent = async t0 => {
  const $ = _c(30);
  const {
    localized: t1
  } = t0;
  const localized = t1 === undefined ? false : t1;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== localized) {
    const t = await getTranslations();
    let t10;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = await getAppLocale();
      $[11] = t10;
    } else {
      t10 = $[11];
    }
    const {
      locale
    } = t10;
    let url = "/";
    if (localized) {
      url = `/${locale}`;
    }
    t8 = "w-full space-y-6 text-center";
    let t11;
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="mb-4 flex justify-center text-red-500"><BadgeX className="h-20 w-20" /></div>;
      t12 = <h1 className="animate-bounce text-4xl font-bold tracking-tighter sm:text-5xl">404</h1>;
      $[12] = t11;
      $[13] = t12;
    } else {
      t11 = $[12];
      t12 = $[13];
    }
    t9 = <div className="space-y-3">{t11}{t12}<h2 className="mb-5 text-2xl font-semibold tracking-tight sm:text-3xl">{t("page_not_found")}</h2><p className="text-gray-500">{t("page_not_found_description")}</p></div>;
    T1 = Button;
    t5 = "lg";
    t6 = "default";
    t7 = true;
    T0 = Link;
    t2 = url;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <HomeIcon />;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t4 = t("return_to_home");
    $[0] = localized;
    $[1] = T0;
    $[2] = T1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    T0 = $[1];
    T1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t10 = <T0 href={t2}>{t3}{t4}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== T1 || $[21] !== t10 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t11 = <T1 size={t5} variant={t6} asChild={t7}>{t10}</T1>;
    $[20] = T1;
    $[21] = t10;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t8 || $[28] !== t9) {
    t12 = <div className={t8}>{t9}{t11}</div>;
    $[26] = t11;
    $[27] = t8;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
export default NotFoundPageContent;